import { addDoc, collection } from 'firebase/firestore';

export interface ActivityLog {
  id?: string;
  createdAt: number;
  dateFormatted: string; // Ej: 12/05/2026
  timeFormatted: string; // Ej: 18:45
  userName: string;
  userRole: string;
  activity: string;
  organizationId: string;
}

export async function logActivity(
  db: any,
  getCollectionPath: (col: string) => string,
  userId: string, // organizationId o sede logueada
  userName: string,
  userRole: string,
  activity: string
) {
  if (!db) return;

  try {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    const dateFormatted = `${dd}/${mm}/${yyyy}`;

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const timeFormatted = `${hours}:${minutes}`;

    const roleMap: Record<string, string> = {
      admin: 'Administrador',
      co_admin: 'Co-Administrador',
      empleado: 'Empleado / Staff',
      gestor_turnos: 'Gestor de Turnos',
      gestor_torneos: 'Gestor de Torneos',
      superadmin: 'Súper Admin',
    };
    const friendlyRole = roleMap[userRole] || userRole || 'Staff';
    const friendlyName = userName || 'Usuario';

    await addDoc(collection(db, getCollectionPath('activity_logs')), {
      createdAt: Date.now(),
      dateFormatted,
      timeFormatted,
      userName: friendlyName,
      userRole: friendlyRole,
      activity,
      organizationId: userId
    });
  } catch (e) {
    console.warn('Error al registrar actividad:', e);
  }
}
